import dayjs, { type Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';

dayjs.extend(customParseFormat);

/** Display format, the same as the worklist: "Jan 10, 1980". */
export const DATE_FORMAT = 'MMM D, YYYY';

/** Formats the calendar accepts when typed; the first is the display. */
export const DATE_INPUT_FORMATS = [
  DATE_FORMAT,
  'YYYY-MM-DD',
  'MM/DD/YYYY',
  'M/D/YYYY',
];

/** Format the API sends and stores context dates in. */
export const API_DATE_FORMAT = 'YYYY-MM-DD';

/** A stored context date ("1980-01-10") as a Dayjs, or null when empty or not a date (the API sends "None"). */
export function parseApiDate(value?: string | null): Dayjs | null {
  if (!value) return null;
  const d = dayjs(value, API_DATE_FORMAT, true);
  return d.isValid() ? d : null;
}
